export default __webpack_public_path__ + "static/media/dolsrs.1ab41d82.svg";